import {
  FETCH_RECURRING_PAYMENT_CARDHOLDER_LOADING,
  FETCH_RECURRING_PAYMENT_CARDHOLDER_SUCCESS,
  FETCH_RECURRING_PAYMENT_CARDHOLDER_FAILED,
} from "../types";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const postRecurringPaymentCardholderReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case FETCH_RECURRING_PAYMENT_CARDHOLDER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RECURRING_PAYMENT_CARDHOLDER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_RECURRING_PAYMENT_CARDHOLDER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
